<script>
    var labels = {
        room_type: 'Stayed In',
        floor: 'Floor'
    }
    export default {
        props: ['entity'],
        mounted() {

        },
        methods: {
            labelize(type) {
                return labels[type]
            }
        }
    }
</script>

<template>
    <div class="review-entity">
        <strong class="light-text mr-2">{{ labelize(entity.type) }}</strong><span class="blue-text">{{ ucFirst(entity.value) }}</span>
    </div>
</template>